<template>
    <b-sidebar
        id="sidebar"
        :visible="isSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        no-close-on-backdrop
        right
        @shown="loadData"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0 text-capitalize">
                    {{ $t('luxriot.editCamera') }}
                </h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>

            <!-- BODY -->
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <!-- Form -->
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <!-- title -->
                    <b-form-group
                        :label="$t('luxriot.name')"
                        label-for="name"
                    >
                        <b-form-input
                            id="name"
                            v-model="itemData.title"
                            :placeholder="$t('luxriot.name')"
                            trim
                            disabled
                        />
                    </b-form-group>

                    <!-- Canal-->
                    <b-form-group
                        :label="$t('luxriot.channel')"
                        label-for="name"
                    >
                        <b-form-input
                            id="name"
                            v-model="itemData.channel_info"
                            :placeholder="$t('luxriot.channel')"
                            trim
                            disabled
                        />
                    </b-form-group>

                    <!-- Master account -->
                    <validation-provider
                        #default="validationContext"
                        name="master_account"
                        rules="required"
                    >
                        <b-form-group
                            :label="$t('luxriot.master_account')"
                            label-for="master_account"
                            :state="getValidationState(validationContext)"
                        >
                            <v-select
                                label="title"
                                v-model="itemData.id_luxriot_master_account"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :placeholder="$t('luxriot.placeholderMasterAccount')"
                                :options="safrMasterAccounts"
                                :clearable="false"
                                :reduce="(account) => account.id"
                                disabled
                                input-id="master_account"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- Alias -->
                    <b-form-group
                        :label="$t('luxriot.alias')"
                        label-for="alias"
                    >
                        <b-form-input
                            id="alias"
                            v-model="itemData.alias"
                            trim
                            :placeholder="$t('luxriot.placeholderAlias')"
                        />
                    </b-form-group>

                    <!-- Delayed_record_minutes -->
                    <validation-provider
                        #default="validationContext"
                        name="delayed_record_minutes"
                        rules="required"
                    >
                        <b-form-group
                            class="text-capitalize"
                            :label="$t('camera.previous_time_of_prealarma')"
                            label-for="delayed_record_minutes"
                        >
                            <flat-pickr
                                id="delayed_record_minutes"
                                class="form-control"
                                :state="getValidationState(validationContext)"
                                :config="{
                                enableTime: true,
                                dateFormat: 'H:i:S',
                                time_24hr: true,
                                noCalendar: true,
                                enableSeconds: true
                                }"
                                v-model="itemData.delayed_record_minutes"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- forward_record_minutes -->
                    <validation-provider
                        #default="validationContext"
                        name="forward_record_minutes"
                        rules="required"
                    >
                        <b-form-group
                            class="text-capitalize"
                            :label="$t('camera.later_time_of_prealarma')"
                            label-for="forward_record_minutes"
                        >
                            <flat-pickr
                                id="forward_record_minutes"
                                class="form-control"
                                :state="getValidationState(validationContext)"
                                :config="{
                                enableTime: true,
                                dateFormat: 'H:i:S',
                                time_24hr: true,
                                noCalendar: true,
                                enableSeconds: true
                                }"
                                v-model="itemData.forward_record_minutes"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- Type -->
                    <validation-provider
                        #default="validationContext"
                        name="type"
                        rules="required"
                    >
                        <b-form-group
                            class="text-capitalize"
                            :label="$t('luxriot.type')"
                            label-for="id_type"
                            :state="getValidationState(validationContext)"
                        >
                            <v-select
                                v-model="itemData.id_type"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :options="camerasTypes"
                                :clearable="false"
                                :reduce="(val) => val.value"
                                input-id="id_type"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>


                    <!-- Centro -->
                    <validation-provider
                        #default="validationContext"
                        name="centers"
                        rules="required"
                    >
                        <b-form-group
                            :label="$t('luxriot.center')"
                            label-for="centers"
                            :state="getValidationState(validationContext)"
                        >
                            <v-select
                                label="name"
                                v-model="itemData.id_center"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :placeholder="$t('luxriot.placeholderCenter')"
                                :options="centers"
                                :clearable="false"
                                :reduce="(center) => center.id"
                                input-id="centers"
                                @input="getCenterSectors($event)"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>


                    <!-- Sectors -->
                    <validation-provider
                        #default="validationContext"
                        name="tenants"
                        rules="required"
                    >
                        <b-form-group
                            :label="$t('luxriot.sector')"
                            label-for="sector"
                            :state="getValidationState(validationContext)"
                        >
                            <v-select
                                label="name"
                                v-model="itemData.id_sector"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :placeholder="$t('luxriot.placeholderSector')"
                                :options="sectors"
                                :clearable="false"
                                :reduce="(sector) => sector.id"
                                input-id="sector"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- Units -->
                    <validation-provider
                        #default="validationContext"
                        name="units"
                        rules="required"
                    >
                        <b-form-group
                            :label="$t('luxriot.units')"
                            label-for="units"
                            :state="getValidationState(validationContext)"
                        >
                            <select-paginate
                                v-model="itemData.units"
                                :items="units"
                                input-id="units"
                                :multiple="true"
                                @change="updateDeviceTags($event)"
                            />

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- Tags -->
                    <validation-provider
                        #default="validationContext"
                        name="tag"
                    >
                        <b-form-group
                            class="text-capitalize"
                            label="Tag"
                            label-for="id_device_tag"
                            :state="getValidationState(validationContext)"
                        >
                            <v-select
                                v-model="itemData.id_device_tag"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :options="deviceTagsOptions"
                                :clearable="false"
                                :reduce="(val) => val.value"
                                input-id="id_device_tag"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <!-- Enable RSTP -->
                    <b-form-checkbox
                        id="rtsp_available"
                        v-model="itemData.rtsp_available"
                        name="rtsp_available"
                        value="1"
                        class="my-1 text-capitalize"
                        unchecked-value="0"
                        switch
                    >
                        {{ $t("camera_proxy.rtsp_available") }}
                    </b-form-checkbox>

                    <validation-provider name="send_to_seproban" rules="required" vid="send_to_seproban">
                        <b-form-checkbox
                        id="send_to_seproban"
                        v-model="itemData.send_to_seproban"
                        name="send_to_seproban"
                        value="1"
                        class="my-1 text-capitalize"
                        unchecked-value="0"
                        switch
                        >
                        {{ $t("camera_proxy.send_to_seproban") }}
                        </b-form-checkbox>
                    </validation-provider>

                    <!-- Form Actions -->
                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mr-2 text-capitalize"
                            type="submit"
                        >
                            {{ isAdd ? $t('actions.add') :$t('actions.edit') }}
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-secondary"
                            @click="hide"
                            class="text-capitalize"
                            >
                                {{$t('actions.cancel')}}
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { required, alphaNum, email, positive, required_if } from "@validations";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from '@/libs/axios';
import SelectPaginate from "../../components/SelectPaginate.vue";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        vSelect,
        BFormCheckbox,

        // Form Validation
        ValidationProvider,
        ValidationObserver,

        SelectPaginate,
        flatPickr,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isSidebarActive',
        event: 'update:is-sidebar-active',
    },
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true,
        },
        itemEdit: {
            type: Object,
            required: false,
        },
        isAdd: {
            type: Boolean,
            required: true,
        },
        units: {
            typeof: Array,
            required: true
        },
        camerasTypes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            required,
            alphaNum,
            email,
            positive,
        };
    },
    setup(props, { emit }) {
        const blankData = {
            title: null,
            alias: null,
            id_luxriot_master_account: null,
            units: [],
            id_sector: null,
            id_type: null,
            delayed_record_minutes: null,
            forward_record_minutes: null,
            id_device_tag: null,
            rtsp_available: false,
            send_to_seproban: false,
        };

        onMounted(async () => {
          store.dispatch('tenant/getDeviceTags');
          await fetchLists()
        });

        //Composables
        const toast = useToast()
        const { t } = useI18nUtils()

        //Data
        const centers = ref([]);

        const itemData = ref(JSON.parse(JSON.stringify(blankData)))

        const safrMasterAccounts = ref([]);

        const sectors = ref([]);

        //Computed
        const titleForm = computed(() => props.isAdd ? t('luxriot.addCamera') : t('luxriot.editCamera'))

        //Methods
        const contentToast = (message,type) => toast({
            component: ToastificationContent,
            props: {
                title: message,
                icon: 'CheckIcon',
                variant: type
            }
        })

        const fetchLists = async () => {
            let apiCenters = await axios.get('/v1/center');
            let apiSafrMasterAccounts = axios.get('/v1/services/luxriot/master-accounts')

            await Promise.all([apiCenters,apiSafrMasterAccounts])
                .then((response) => {
                    let [responseCenters,responseSafrMasterAccount] = response;

                    centers.value = responseCenters.data.data;
                    safrMasterAccounts.value = responseSafrMasterAccount.data.data;
                }).catch(() => {
                        safrMasterAccounts.value = [];
                        sectors.value = [];
                    });
        }

        const getCenterSectors = async (id_center, initIdSector = true) => {
            let requestSector = {
                id_center: [id_center]
            }

            let { data } = await axios.get('/v1/sector', { params: requestSector })

            if (initIdSector) {
                itemData.value.id_sector = null
            }

            sectors.value = data.data
        }

        const onSubmit = async () => {
            try {
                let { data } = await axios.put(`/v1/services/luxriot/cameras/${itemData.value.id}`, { camera: itemData.value })
                let { message, success } = data

                contentToast(message,'success')
                emit('refetch-data')
                emit('update:is-sidebar-active', false)
            } catch (error) {
                let { message } = error.response.data

                contentToast(message,'danger')
            }
        }

        const updateDeviceTags = (unitsParam) => {
            let idsTenants = unitsParam.map((unit) => unit.id_tenant)

            store.dispatch("tenant/getDeviceTagsByTenantIds", { id_tenants: idsTenants });
        }

        const resetData = () => {
            itemData.value = JSON.parse(JSON.stringify(blankData))
        };

        const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

        const loadData = () => {
            if (!props.isAdd) {
                itemData.value = props.itemEdit;

                if (itemData.value.camera.units.length) {
                    itemData.value.units = props.itemEdit.camera.units.map((value) => ({
                        value: value.id,
                        label: value.description,
                        id_tenant: value.router.id_tenant,
                    }));
                }

            }
        }

        const deviceTagsOptions = computed(() => {
            return store.getters["tenant/getDeviceTags"].map((item) => ({
                label: item.name,
                value: item.id
            }))
        })

        return {
            itemData,
            onSubmit,

            refFormObserver,
            getValidationState,
            loadData,
            resetForm,
            centers,
            safrMasterAccounts,
            sectors,

            getCenterSectors,
            updateDeviceTags,
            titleForm,
            deviceTagsOptions
        };
    }
};
</script>
